<div class="parent">
  <mat-card appearance="outlined" class="example-card">
    <mat-card-header>
      <mat-card-title>{{ 'Registration completed!' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="alert" [ngClass]="{ 'alert-success': this.success === true, 'alert-danger': this.error === true }">{{message}}</div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button (click)="onSignIn()" [disabled]="error">{{ 'Login' | translate}}</button>
    </mat-card-actions>
  </mat-card>
</div>
